/*
 * Ambient seasonal effects. The server decides the season and puts the effect classes on <body>,
 * so the library is only downloaded when a page actually asks for it.
 *
 * halloween.js attaches its effects layer to the <body> it first sees, but wire:navigate swaps in
 * a whole new <body> on every page change. The layer is carried across the swap and the library
 * is then told to re-read the classes on the new body.
 */
class LambdaSeasonalEffects
{
	static syncHalloween = null;
	static halloweenPageLayer = null;

	static async init()
	{
		if (this.halloweenPageLayer !== null && !document.body.contains(this.halloweenPageLayer)) {
			document.body.appendChild(this.halloweenPageLayer);
		}

		if (this.syncHalloween !== null) {
			this.syncHalloween();
			return;
		}

		if (document.body.classList.contains('halloween')) {
			const { halloween } = await import('halloween.js');
			this.syncHalloween = halloween;
		}
	}

	static rememberPageLayer()
	{
		this.halloweenPageLayer = document.querySelector('.halloween-page-layer') ?? this.halloweenPageLayer;
	}
}

export default LambdaSeasonalEffects;
